import { render, staticRenderFns } from "./right-sheet-ayuda.vue?vue&type=template&id=3f2ee8f1&scoped=true&"
import script from "./right-sheet-ayuda.vue?vue&type=script&lang=js&"
export * from "./right-sheet-ayuda.vue?vue&type=script&lang=js&"
import style0 from "./right-sheet-ayuda.vue?vue&type=style&index=0&id=3f2ee8f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2ee8f1",
  null
  
)

export default component.exports